import { connect, ConnectedProps } from 'react-redux';
import { ReduxState } from '../../interfaces';
import { FC, useState } from 'react';
import { Card, ConfirmationModal } from '../../utilities/components';
import { ReactComponent as LockIcon } from 'assets/icons/security/Lock.svg';
import { ReactComponent as PasswordIcon } from 'assets/icons/security/Password.svg';
import { ReactComponent as LoginIcon } from 'assets/icons/security/Login.svg';
import { Button } from '../components';
import PasswordModal from './passwordModal/passwordModal.index';
import GoogleAuthenticationModal from './googleAuthenticationModal/googleAuthenticationModal.index';

interface OwnProps {}

type Props = OwnProps & ConnectedProps<typeof connector>;

const Security: FC<Props> = (props) => {
    const [sessionModalOpen, setSessionModalOpen] = useState<boolean>(false);
    const [passwordModalOpen, setPasswordModalOpen] = useState<boolean>(false);
    const [googleModalOpen, setGoogleModalOpen] = useState<boolean>(false);

    return (
        <div className={'flex flex-col gap-6 p-6'}>
            <ConfirmationModal
                onConfirm={() => {
                    console.log();
                }}
                onClose={() => setSessionModalOpen(false)}
                isOpen={sessionModalOpen}
                title={'خروج از دستگاه‌های فعال'}
                message={'شما قصد خروج از تمام دستگاه‌هایی که حساب کاربری شما در آن فعال است را دارید.'}
                submitButtonText={'خارج می شوم!'}
            />
            <PasswordModal open={passwordModalOpen} setOpen={setPasswordModalOpen} />
            <GoogleAuthenticationModal
                open={googleModalOpen}
                setOpen={setGoogleModalOpen}
                isActive={props.user?.twoFactor.isActive && props.user?.twoFactor.type.id === 2}
            />
            <Card>
                <div className={'flex justify-between'}>
                    <div className={'flex gap-4'}>
                        <LockIcon />
                        <div className={'flex flex-col gap-2'}>
                            <span className={'text-xl font-bold'}>رمز عبور</span>
                            <span className={'text-base font-normal'}>
                                جهت تغییر رمز عبور از دکمه (تغییر رمز عبور) اقدام فرمایید.
                            </span>
                        </div>
                    </div>
                    <Button type={'primary'} className={'!h-10 self-end'} onClick={() => setPasswordModalOpen(true)}>
                        تغییر رمز عبور
                    </Button>
                </div>
            </Card>

            <Card>
                <div className={'flex justify-between'}>
                    <div className={'flex gap-4'}>
                        <PasswordIcon />
                        <div className={'flex flex-col gap-2'}>
                            <span className={'text-xl font-bold'}>شناسایی دو عاملی</span>
                            <span className={'text-base font-normal'}>
                                اجباری برای برداشت رمز ارز و انتقال , اختیاری جهت افزایش امنیت ورود به حساب کاربری
                            </span>
                        </div>
                    </div>
                    <Button
                        type={'primary'}
                        className={'!h-10 self-end'}
                        onClick={() => {
                            setGoogleModalOpen(true);
                        }}
                    >
                        {props.user?.twoFactor.isActive && props.user?.twoFactor.type.id === 2
                            ? 'غیر فعال سازی'
                            : 'فعال سازی'}
                    </Button>
                </div>
            </Card>

            <Card>
                <div className={'flex justify-between'}>
                    <div className={'flex gap-4'}>
                        <LoginIcon />
                        <div className={'flex flex-col gap-2'}>
                            <span className={'text-xl font-bold'}>خروج از دستگاه‌های فعال</span>
                            <span className={'text-base font-normal'}>
                                خروج از تمام دستگاه هایی که حساب کاربری شما در آن فعال است.
                            </span>
                        </div>
                    </div>
                    <Button type={'primary'} className={'!h-10 self-end'} onClick={() => setSessionModalOpen(true)}>
                        خروج از همه
                    </Button>
                </div>
            </Card>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(Security);
